import React from "react";
import "./Contact.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import logocontact from "../../../Images/logocontact.jpeg"
import logo from "../../../Images/L.png";

const Contact = () => {
  return (
    <section className="contact-section">
      <div className="contact-header">
        <h2>Get In Touch</h2>
        <p>
          We’d love to hear from you! Fill out the form and we’ll get back to you as soon as possible.
        </p>
      </div>

      <div className="contact-wrapper">
        {/* Left Side - Contact Form */}
       <div className="contact-card info-card">
  {/* Logo */}
  <div className="contact-logo">
    <img src={logocontact} alt="Hello Mobiles Logo" />
  </div>

  {/* Info Table */}
  <div className="info-table">

    <div className="info-row">
      <i className="fas fa-envelope"></i>
      <span>    akshayamsilksreadymades@gmail.com</span>
    </div>

    <div className="info-row">
      <i class="fa-solid fa-phone"></i>
      <span>+91 04652-318654</span>
    </div>

    

    <div className="info-row">
      <i className="fas fa-map-marker-alt"></i>
      <span>203A/1 Rajakkamangalam Road, Punnainagar Junction, Nagercoil-629004
</span>
    </div>

  </div>

  {/* Social Icons */}
  <div className="contact-socials">
    <a  href="https://www.facebook.com/share/17HNFGxLhK/" target="_blank">
      <i className="fab fa-facebook-f"></i>
    </a>
    <a href="https://www.instagram.com/akshayamsilks_nagercoil?igsh=OW95NXE2c3A0djJu" target="_blank">
      <i className="fab fa-instagram"></i>
    </a>
    <a href="https://wa.me/918610893897" target="_blank">
      <i className="fab fa-whatsapp"></i>
    </a>
  </div>
</div>

        {/* Right Side - Map Only */}
        <div className="contact-card map-card">
          <div className="map-frame">
           <iframe
  title="Location at 203A/1 Rajakkamangalam Road"
src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3948.020898228487!2d77.4430253745788!3d8.19192259185168!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3b04f1f6f8f9241d%3A0x8b8a85edb720674f!2s5C89%2BVP%20Nagercoil%2C%20Tamil%20Nadu!5e0!3m2!1sen!2sin!4v1731249455579!5m2!1sen!2sin"  width="100%"
  height="100%"
  style={{ border: 0 }}
  allowFullScreen=""
  loading="lazy"
  referrerPolicy="no-referrer-when-downgrade"
/>

          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
